const TRANSLATIONS = {
  English: {
    addPasswordHere: 'Add a Password Here',
    createYour: 'Create Your',
    nbcUniversalProfile: 'NBCUniversal Profile',
    whatsNbcUniversalProfile: 'What is an NBCUniversal Profile?',
    createProfileWithEmail: 'Create profile with email',
    createdProfileWithFacebook: 'Created profile with Facebook?',
    logIn: 'Log in',
    logInToYour: 'Log in to Your',
    orWord: 'OR',
    logInWithPassword: 'Log in with password',
    logInWithPasswordHeader: 'Log in with password',
    alreadyHaveNbcProfile: 'Already have an NBCUniversal Profile?',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    continueWithOneTimeCode: 'Continue with One-time Code',
    continueWithEmail: 'Continue with email',
    continueWithPasskey: 'Continue with a passkey',
    weAreAlwaysAddingNewContentAndBrands:
      "We're always adding new content and brands.",
    checkBackForMore: 'Check back for more!',
    whatsNewFeatures: [
      'Stay up-to-date on all your<br />NBCUniversal shows and content.',
      'Connect your devices for access<br />anywhere, anytime.',
      'Credits for premium, exclusive<br />content and special perks.',
    ],
    createProfile: 'Create profile',
    required: 'required',
    videoViewingPolicyLineStart: 'I have read and agree to the NBCUniversal',
    videoViewingPolicyLineTwo: 'Video Viewing Policy.',
    man: 'Man',
    woman: 'Woman',
    noneAbove: 'None of the above',
    preferNotToSay: 'Prefer not to say',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    fieldCannotContainSpecialChars:
      'This field cannot contain special characters or numbers.',
    enterValidZipCode: 'Please enter a valid zip code.',
    phoneNumberCanOnlyContainDigits: 'Phone number can only contain digits.',
    zipCodeCanOnlyContainDigits: 'Zip code can only contain digits.',
    phoneNumberMustBeTenChars: 'Phone number must be ten characters',
    pleaseEnterValidPassword: 'Please enter a valid password.',
    pleaseEnterValidFirstName: 'Please enter a valid first name.',
    pleaseEnterValidLastName: 'Please enter a valid last name.',
    pleaseSelectBirthYear: 'Please select a valid birth year.',
    pleaseEnterValidStreetAddress: 'Please enter a valid street address.',
    pleaseEnterValidAptSuite: 'Please enter a valid apt, suite, unit, building.',
    pleaseEnterValidCity: 'Please enter a valid city.',
    pleaseSelectState: 'Please select a state.',
    pleaseSelectGender: 'Please select a gender.',
    pleaseEnterValidZipCode: 'Please enter a valid zip code.',
    pleaseEnterValidPhoneNumber: 'Please enter a valid phone number.',
    pleaseEnterValidEmail: 'Please enter a valid email address.',
    pleaseEnterValidOTC: 'Please enter a valid code.',
    firstName: 'First Name',
    lastName: 'Last Name',
    birthDay: 'Birth Day',
    birthMonth: 'Birth Month',
    birthYear: 'Birth Year',
    gender: 'Gender',
    streetAddress: 'Street Address',
    aptSuiteUnitBuilding: 'Apt, Suite, Unit, Building',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    phoneNumber: 'Phone Number',
    email: 'Email',
    password: 'Password',
    passwordLowercase: 'password',
    atleast10Chars: 'At least 10 characters',
    lessThan50Characters: 'Cannot exceed 50 characters',
    containsALetter: 'Contains a letter',
    containsANumber: 'Contains a number',
    cannotContainYourEmail: 'Your email cannot be your password',
    cannotContain: 'Cannot contain',
    cannotContainSpecialCharacters: '\u003C\u003E\u0026 or spaces', // '< > & or space',
    cannotContainPassword: '"password"',
    emailAddress: 'email address',
    incorrectEmailOrPassword: 'Incorrect email or password. Please try again.',
    forgotPassword: 'Forgot password?',
    dontHaveNbcUniversalProfile: "Don't have an NBCUniversal Profile?",
    privacyPolicy: 'Privacy Policy',
    addShippingInformation: 'Add Shipping Information',
    toYourProfile: 'to Your Profile',
    nowYouCanUnlockFasterCheckout:
      'Now you can unlock a faster checkout experience by adding your shipping address to your profile!',
    saveAndContinue: 'Save and continue',
    completeMyProfile: 'Complete my profile',
    completeYour: 'Complete Your',
    youHaveOptionToPersonalize: 'You have the option to personalize',
    yourExperienceEvenMore: 'your experience even more!',
    showPassword: 'Show Password',
    hidePassword: 'Hide Password',
    youAreCreatingProfileUsing:
      "You're creating a NBCUniversal Profile using:",
    with: 'with',
    addForFree: 'Add for FREE',
    justCreatePassword: 'Just create a password.',
    iAgreeToTheMasculinePlural: 'I agree to the',
    termsOfUse: 'Terms of Use',
    andWord: 'and',
    signUp: 'Sign Up',
    successMessage:
      'Welcome to NBCUniversal! Explore content across multiple brands.',
    profileAlreadyExistChooseAnother:
    "A profile already exists for this email. Select 'Log in' or use a different email to create your profile.",
    close: 'Close',
    skip: 'Skip',
    lockedAccount: 'Too many attempts to login. Please try logging in later.',
    continueToLogin: 'Continue to log in',
    continue: 'Continue',
    back: 'Back',
    previousLogin: 'You previously logged in using',
    your: 'your',
    wouldContinue: 'Would you like to continue?',
    continueLoggingIn: 'Continue logging in',
    loginDifferentProfile: 'Log in using different profile',
    oneMoment: 'One Moment Please...',
    thisShouldOnlyTake: 'This should only take a few more seconds.',
    workingOnRequest: 'We are working on processing your request',
    thankYouForPatience: 'thank you for your patience',
    getAOneTimeCodeSentLineOne: 'Get a one-time code sent to your email',
    getAOneTimeCodeSentLineTwo: 'that will log you in instantly!',
    getMyCodeButtonText: 'Get my code',
    getMyCodeErrorMsg: "We couldn't find a profile with the provided email. Please try again or create a new profile.",
    enterOneTimeCode: 'Enter One-time Code',
    enterOneTimeCodeWeSentTo: 'Enter the one-time code we sent to',
    ifYouCouldntFind: "If you couldn't find our email,",
    plaseCheckYour: 'please check your spam folder.',
    oneTimeCodeLabel: 'One-time Code',
    oneTimeCodeExpired: "This code has expired, please select 'Resend code' to receive a new one.",
    stillCantFindIt: "Still can't find it?",
    resendEmail: 'Resend Email',
    invalidOrExpiredCodeErrorMsg: "This code is either invalid or expired, please try again or select 'Resend code' for a new one.",
    codeResentSuccessfully: 'Your one-time code has been resent successfully.',
    keepUpWithFavShows: 'Keep up with your<br/>favorite shows!',
    wantTheLastestSentToYourInbox: 'Want the latest and greatest sent straight to your inbox?<br/>Use your email address to create an NBCUniversal<br/>Profile - no password needed! - and join our list.',
    thanksForSigningUpYourProfileIsReady: 'Thanks for signing up,<br/>Your profile is ready!',
    youWillNowReceiveAllTheLatest: 'You will now receive all the latest on your<br/>favorite movies and shows!',
    signMeUp: 'Sign me up',
    selectAllCheckboxes: 'Select all checkboxes to proceed.',
    pleaseSelectAllCheckboxes: 'Please select all checkboxes to proceed.',
    anErrorHasOcurred: 'An error has occurred. Please try again later.',
    maybeLater: 'Maybe later',
    showMore: 'Show more',
    logInNow: 'Log in Now',
    profileCouldNotAuthThroughApple: 'Profile could not be authenticated through Apple.',
    havingTroubleLoggingIn: 'Having trouble?',
    otherLoginOptions: 'Other login options',
    sendCodeAgain: 'Resend code',
    enterCode: 'Enter code',
    aNewCode: 'A new code has been sent to your email.',
    havingTroubleLoggingInCapitalCase: 'Having Trouble Logging in?',
    tryTheBelowLoginOptions: 'Try the below login options or contact us with your issue',
    logInWithOTC: 'Log in with One-time Code',
    stillCantLogIn: "Still can't log in?",
    contactUs: 'Contact us',
    leave: 'leave',
    leavePage: 'Ready to leave this page?',
    confirmModalText: 'You\'ll be logged out of your NBCUniversal Profile<br>and changes you made may not be saved',
    notNowLink: 'Not Now',
    createPasskey: 'Create a passkey for your<br/>NBCUniversal Profile login',
    createPasskeyThisDevice: 'Create your passkey on this device',
    usePasskeyOtherDevice: 'Use a saved passkey from another device',
    usePasskeyOtherDeviceText: 'We detected a passkey saved on another device, do you wish to log in with your existing passkey?',
    loginSavedPasskey: 'LOG IN WITH SAVED PASSKEY ',
    setUpPasskeyThisDeviceText: 'Make your login effortless by creating a new passkey on this device. You’ll be able to log in to your profile with your fingerprint, face, or screen passcode.',
    setUpPasskeyThisDeviceTextComplement: 'Please note, if this is a shared device don’t create a new passkey.',
    setUpPasskeyText: 'Setting up your passkey allows you to log in to your NBCUniversal Profile without a password (e.g., using your fingerprint, face, or screen passcode instead).',
    setUpPasskeyTextComplement: 'Please note, if this is a shared device, don\'t create a passkey.',
    passKeyCreatedTitle: 'Passkey has been created! ',
    passKeyCreatedDescription: 'You’ll be able to log in to your profile with your fingerprint, face, or screen passcode.',
    createPasskeyErrorTitle: 'Unable to save passkey',
    createPasskeyErrorAlreadyRegisteredErrorTitle: 'You already created a passkey using this device',
    createPasskeyErrorGenericErrorDescription: 'Oops, something went wrong!<br />Please try again or create your passkey later.',
    createPasskeyErrorAlreadyRegisteredErrorDescription: 'A passkey already exists with your current device.<br/>You can create a passkey using another device.',
    tryAgain: 'Try again',
    createPasskeyButton: 'Create your Passkey',
    useAnotherDevice: 'Use another device',
    passkeyAuthFailedError: 'Oops! We couldn\'t log you in with passkey. Please try again or explore other login options below.',
    passkeyLoadingOverlayText: 'One moment while<br/>we log you in...',
    oauthSuccessMessageHeader: 'Welcome to your<br/>NBCUniversal Profile',
    oauthSuccessSubTitle: 'Your journey across all NBCUniversal brands starts from here! You can now continue to Bravo with exclusive access...',
    oauthSuccessButton: 'Explore NBCUniversal',
    passkeyLoginFailed: 'Oops! We couldn\'t log you in with passkey. Please try again or explore other login options below.',
    invalidLoginMethod: 'You are attempting to access a profile not associated with this log in method. Please try again.',
    loginOrCreateProfile: 'Log in or create an<br/>NBCUniversal Profile',
    previewMode: 'You are currently in Preview Mode. Please note that you are viewing a draft and any changes made have not been saved to your OAuth configuration.',
    enterActivationCode: 'Enter the activation code<br/>displayed on your TV.',
    preferencesErrorGenericErrorDescription: 'Oops, something went wrong! Please try again later.',
    enterTheOTC: 'Enter the one-time code',
    letsCreateAPasskey: "Let's create a passkey.",
    enhanceYourProfileSecurity: 'Enhance your profile security by logging in using your fingerprint, face ID, or screen passcode.',
    verifyYourEmail: 'Verify your email<br/>and create a passkey',
    pleaseEnterTheOTC: 'Please enter the one-time code we sent to',
    createPasskeySingleText: 'Create passkey',
    youAreAllSet: 'You are all set!',
    aPasskeyHasBeenCreated: 'A passkey has been created for your NBCUniversal Profile! You’ll now be able to log in with your fingerprint, face, or screen passcode.',
    thereAreNoResultsThatMatch: 'There are no results that match "%search%"',
    ctvSuccessHeader: 'You are ready to stream!',
    ctvSuccessText: 'You have successfully activated your device using your NBCUniversal Profile. Your device will refresh to continue.',
    ctvLeftTitle: 'Use your NBCUniversal Profile',
    ctvLeftSubtitle: 'to activate device and unlock content instantly',
    ctvSuccessSubtitle: 'Your journey across all NBCUniversal brands starts from here! You can now continue to explore.',
    createProfilePasskeyFlowWelcomeVar2: 'Now you can set up a passkey and log in using your fingerprint, face ID, or screen passcode. To enable passkey login, please enter the one-time code we sent to',
  },
  Spanish: {
    addPasswordHere: 'Agrega una contraseña aquí',
    createYour: 'Crea Tu',
    nbcUniversalProfile: 'Perfil de NBCUniversal',
    whatsNbcUniversalProfile: '¿Qué es un perfil NBCUniversal?',
    createProfileWithEmail: 'Crea tu perfil con email',
    createdProfileWithFacebook: 'Creaste tu perfil con Facebook?',
    logIn: 'Iniciar Sesión',
    logInToYour: 'Inicia sesión a tu',
    orWord: 'O',
    logInWithPassword: 'Iniciar sesión con contraseña',
    logInWithPasswordHeader: 'Iniciar sesión con Contraseña',
    alreadyHaveNbcProfile: '¿Ya tienes un Perfil de NBCUniversal?',
    continueWithGoogle: 'Continuar con google',
    continueWithApple: 'Continuar con Apple',
    continueWithOneTimeCode: 'Continuar con el código de un solo uso',
    continueWithEmail: 'Continúa con tu correo electrónico',
    continueWithPasskey: 'Continuar con una clave de acceso',
    weAreAlwaysAddingNewContentAndBrands:
      'Siempre estamos agregando nuevos contenidos y plataformas.',
    checkBackForMore: '¡Vuelve para saber más!',
    whatsNewFeatures: [
      'Manténte actualizado sobre todos tus programas y contenido de NBCUniversal.',
      'Conecta tus dispositivos para acceder en cualquier lugar y en cualquier momento.',
      'Créditos para premium, contenido exclusivo y beneficios especiales.',
    ],
    createProfile: 'Crear perfil',
    required: 'requerido',
    videoViewingPolicyLineStart: 'He leído y estoy de acuerdo con NBCUniversal',
    videoViewingPolicyLineTwo: 'Video Viewing Policy.',
    man: 'Hombre',
    woman: 'Mujer',
    noneAbove: 'Ninguno de los anteriores',
    preferNotToSay: 'Prefiero no revelar',
    january: 'Enero',
    february: 'Febrero',
    march: 'Marzo',
    april: 'Abril',
    may: 'Mayo',
    june: 'Junio',
    july: 'Julio',
    august: 'Agosto',
    september: 'Septiembre',
    october: 'Octubre',
    november: 'Noviembre',
    december: 'Diciembre',
    fieldCannotContainSpecialChars:
      'Este campo no puede contener caracteres especiales o números.',
    enterValidZipCode: 'Por favor ingrese un código postal válido.',
    phoneNumberCanOnlyContainDigits:
      'Números telefónicos solo pueden contener cifras',
    zipCodeCanOnlyContainDigits: 'El código postal solo puede contener dígitos.',
    phoneNumberMustBeTenChars:
      'Números telefónicos deben de contener diez caracteres',
    pleaseEnterValidPassword: 'Por favor ingrese una contraseña válida.',
    pleaseEnterValidFirstName: 'Por favor, ingresa un nombre válido.',
    pleaseEnterValidLastName: 'Por favor, ingresa un apellido válido.',
    pleaseSelectBirthYear: 'Seleccione un año de nacimiento.',
    pleaseEnterValidStreetAddress: 'Por favor ingresa una dirección válida.',
    pleaseEnterValidAptSuite: 'Por favor ingresa un apt, suite, unidad, edificio válido.',
    pleaseEnterValidCity: 'Por favor ingresa una ciudad válida.',
    pleaseSelectState: 'Por favor ingrese un estado.',
    pleaseSelectGender: 'Seleccione un género.',
    pleaseEnterValidZipCode: 'Por favor ingrese un código postal válido.',
    pleaseEnterValidPhoneNumber: 'Por favor ingrese un número de teléfono.',
    pleaseEnterValidEmail: 'Por favor, ingresa una dirección de correo electrónico válida.',
    pleaseEnterValidOTC: 'Por favor ingrese un código válido.',
    firstName: 'Nombre',
    lastName: 'Apellido',
    birthDay: 'Día de nacimiento',
    birthMonth: 'Mes de nacimiento',
    birthYear: 'Año de nacimiento',
    gender: 'Género',
    streetAddress: 'Dirección',
    aptSuiteUnitBuilding: 'Apt, Suite, Unidad, Edificio',
    city: 'Ciudad',
    state: 'Estado',
    zipCode: 'Codigo Postal',
    phoneNumber: 'Número de Teléfono',
    email: 'Email',
    password: 'Contraseña',
    passwordLowercase: 'password',
    atleast10Chars: 'Al menos 10 caracteres',
    lessThan50Characters: 'No puede exceder los 50 caracteres',
    containsALetter: 'Al menos una letra',
    containsANumber: 'Al menos un número',
    cannotContainYourEmail: 'Tu correo electrónico no puede ser tu contraseña',
    cannotContain: 'No puede contener',
    cannotContainSpecialCharacters: '\u003C\u003E\u0026 ni espacios', // '< > & or space',
    cannotContainPassword: '"password"',
    emailAddress: 'correo electrónico',
    incorrectEmailOrPassword: 'Correo electrónico o contraseña incorrecta. Por favor, inténtelo más tarde.',
    forgotPassword: '¿Has olvidado tu contraseña?',
    dontHaveNbcUniversalProfile: '¿No tienes un Perfil de NBCUniversal?',
    privacyPolicy: 'Política de Privacidad',
    addShippingInformation: 'Agregue la Información de',
    toYourProfile: 'Envío a Su Perfil',
    nowYouCanUnlockFasterCheckout:
      '¡Ahora puede desbloquear una experiencia de pago más rápida agregando la dirección de envío a su perfil!',
    saveAndContinue: 'Guardar y continuar',
    completeMyProfile: 'Completar mi perfil',
    completeYour: 'Completa tu',
    youHaveOptionToPersonalize: '¡Tienes la opción de personalizar',
    yourExperienceEvenMore: 'tu experiencia aún más!',
    showPassword: 'Mostrar Contraseña',
    hidePassword: 'Ocultar Contraseña',
    youAreCreatingProfileUsing: 'Estás creando un perfil NBCUniversal usando',
    with: 'con',
    addForFree: 'Añadir GRATIS',
    justCreatePassword: 'Simplemente crea una contraseña.',
    iAgreeToTheMasculinePlural: 'Estoy de acuerdo con los',
    termsOfUse: 'Términos de Uso',
    andWord: 'y',
    signUp: 'Regístrate',
    successMessage:
      '¡Bienvenido a NBCUniversal! Explore el contenido de multiples plataformas.',
    profileAlreadyExistChooseAnother:
      "Ya existe un perfil con este correo electrónico. Selecciona 'Iniciar sesión' o utiliza un correo diferente para crear tu perfil.",
    close: 'Cerrar',
    skip: 'Saltar',
    lockedAccount: 'Se han realizado demasiados intentos para ingresar. Por favor, inteńtelo más tarde.',
    continueToLogin: 'Continuar para iniciar sesión',
    continue: 'Continuar',
    back: 'Atrás',
    previousLogin: 'Ya habías iniciado sesión con',
    your: 'tu',
    wouldContinue: '¿Deseas continuar?',
    continueLoggingIn: 'Continuar iniciando sesión',
    loginDifferentProfile: 'Iniciar sesión con un perfil diferente',
    oneMoment: 'Un momento por favor...',
    thisShouldOnlyTake: 'Esto debería tomar solo unos segundos.',
    workingOnRequest: 'Estamos trabajando en el procesamiento de su solicitud',
    thankYouForPatience: 'gracias por su paciencia',
    getAOneTimeCodeSentLineOne: '¡Obtenga un código de un solo uso enviado a',
    getAOneTimeCodeSentLineTwo: 'su correo electrónico que lo iniciará al instante!',
    getMyCodeButtonText: 'Obtener mi código',
    getMyCodeErrorMsg: 'No logramos encontrar un perfil con el correo electrónico proveído. Por favor inténtelo de nuevo o cree un perfil nuevo.',
    enterOneTimeCode: 'Ingrese el código de un solo uso',
    enterOneTimeCodeWeSentTo: 'Ingresa el código único que enviamos a',
    ifYouCouldntFind: 'Si no pudo encontrar nuestro correo electrónico,',
    plaseCheckYour: 'verifique su carpeta de correo no deseado.',
    oneTimeCodeLabel: 'Código de un solo uso',
    oneTimeCodeExpired: 'Este código ha caducado. Selecciona "Reenviar código" para recibir uno nuevo.',
    stillCantFindIt: '¿Todavía no logras encontrarlo?',
    resendEmail: 'Reenviar correo electrónico',
    invalidOrExpiredCodeErrorMsg: 'Este código no es válido o ha caducado. Intenta nuevamente o selecciona "Reenviar código" para recibir uno nuevo.',
    codeResentSuccessfully: 'Tu código temporal ha sido reenviado exitosamente.',
    keepUpWithFavShows: '¡Mantente al día con tus series favoritas!',
    wantTheLastestSentToYourInbox: '¿Quieres recibir lo último directo a tu buzón? Usa tu correo electrónico para crear un Perfil de NBCUniversal - ¡sin necesitar una contraseña! - y únete a nuestra lista.',
    thanksForSigningUpYourProfileIsReady: '¡Gracias por registrarte! Tu perfil está listo.',
    youWillNowReceiveAllTheLatest: '¡Ahora recibirás todo lo último sobre tus series y películas favoritas!',
    signMeUp: 'Inscríbeme',
    selectAllCheckboxes: 'Seleccione todos los casilleros para continuar.',
    pleaseSelectAllCheckboxes: 'Por favor, seleccione todos los casilleros para continuar.',
    anErrorHasOcurred: 'Se ha producido un error. Por favor inténtelo más tarde.',
    maybeLater: 'Tal vez luego',
    showMore: 'Mostrar más',
    logInNow: 'Ingresar ahora',
    profileCouldNotAuthThroughApple: 'El perfil no pudo ser autenticado a través de Apple.',
    otherLoginOptions: 'Otras opciones para iniciar sesión',
    sendCodeAgain: 'Reenviar código',
    enterCode: 'Ingresar código',
    aNewCode: 'Un código nuevo ha sido enviado a su correo electrónico.',
    havingTroubleLoggingIn: '¿Tienes dificultades?',
    tryTheBelowLoginOptions: 'Intente las siguientes opciones para iniciar sesión o contáctenos con su problema',
    logInWithOTC: 'Iniciar sesión con un código temporario',
    stillCantLogIn: '¿Todavía no puede ingresar?',
    contactUs: 'Contáctenos',
    leave: 'salir',
    leavePage: '¿Listo para salir de esta página?',
    confirmModalText: 'Estará cerrando su sesión de perfil con NBCUniversal y los cambios que haya hecho podrían no ser guardados.',
    notNowLink: 'Aún No',
    createPasskey: 'Crea una clave de acceso<br />para tu inicio de sesión en el<br />Perfil de NBCUniversal',
    createPasskeyThisDevice: 'Crea tu clave de acceso en este dispositivo',
    usePasskeyOtherDevice: 'Usar una clave de acceso guardada desde otro dispositivo ',
    usePasskeyOtherDeviceText: 'Hemos detectado una clave de acceso guardada en otro dispositivo, ¿deseas iniciar sesión con tu clave de acceso existente?',
    loginSavedPasskey: 'INICIAR SESIÓN CON LA CLAVE DE ACCESO GUARDADA',
    setUpPasskeyThisDeviceText: '"Haz que tu inicio de sesión sea sin esfuerzo creando una nueva clave de acceso en este dispositivo. Podrás iniciar sesión en tu perfil con tu huella dactilar, rostro o código de acceso de pantalla.',
    setUpPasskeyThisDeviceTextComplement: 'Por favor, ten en cuenta que si este es un dispositivo compartido, no debes crear una nueva clave de acceso.',
    setUpPasskeyText: '"Configurar tu clave de acceso te permite iniciar sesión en tu Perfil de NBCUniversal sin contraseña (por ejemplo, utilizando tu huella dactilar, rostro o código de acceso de pantalla en su lugar).',
    setUpPasskeyTextComplement: 'Por favor, ten en cuenta que si este es un dispositivo compartido, no debes crear una nueva clave de acceso.',
    passKeyCreatedTitle: '¡Se ha creado la clave de acceso!',
    passKeyCreatedDescription: 'Podrás iniciar sesión en tu perfil con tu huella dactilar, rostro o código de acceso de pantalla.',
    createPasskeyErrorTitle: 'No se pudo guardar su<br />clave de acceso',
    createPasskeyErrorAlreadyRegisteredErrorTitle: 'Ya creaste una contraseña utilizando este dispositivo',
    createPasskeyErrorGenericErrorDescription: 'Oops, ¡algo salió mal!<br />Por favor inténtelo de nuevo o<br />cree su clave de acceso más tarde.',
    createPasskeyErrorAlreadyRegisteredErrorDescription: 'Ya existe una clave de paso con tu dispositivo actual.<br />Puedes crear una clave de paso usando otro dispositivo.',
    tryAgain: 'Intentarlo de nuevo',
    createPasskeyButton: 'Crear tu clave de acceso',
    useAnotherDevice: 'Usar otro dispositivo',
    passkeyAuthFailedError: '¡Ups! No pudimos iniciar sesión con la clave de acceso. Por favor, inténtalo de nuevo o explora otras opciones de inicio de sesión a continuación.',
    passkeyLoadingOverlayText: 'Un momento mientras<br/>iniciamos tu sesión...',
    oauthSuccessMessageHeader: 'Bienvenido a su Perfil de NBCUniversal',
    oauthSuccessSubTitle: '¡Su viaje a través de todas las marcas de NBCUniversal empieza aquí! Ya puede continuar a Bravo con acceso exclusivo...',
    oauthSuccessButton: 'Explore NBCUniversal',
    passkeyLoginFailed: '¡Ups! No pudimos iniciar sesión con la clave de acceso. Inténtalo de nuevo o explora otras opciones de inicio de sesión a continuación.',
    invalidLoginMethod: 'Está intentando acceder a un perfil no asociado con este método de inicio de sesión. Inténtalo de nuevo.',
    loginOrCreateProfile: 'Iniciar sesión o crear un<br/>Perfil de NBCUniversal',
    previewMode: 'You are currently in Preview Mode. Please note that you are viewing a draft and any changes made have not been saved to your OAuth configuration.',
    enterActivationCode: 'Enter the activation code<br/>displayed on your TV.',
    preferencesErrorGenericErrorDescription: 'Oops, ¡algo salió mal! Por favor inténtelo de nuevo más tarde.',
    enterTheOTC: 'Ingresa el código temporal',
    letsCreateAPasskey: 'Vamos a crear una clave de acceso',
    enhanceYourProfileSecurity: 'Mejora la seguridad de tu perfil iniciando sesión con tu huella digital, reconocimiento facial o código de desbloqueo de pantalla.',
    verifyYourEmail: 'Verifica tu correo electrónico<br/>y crea una clave de acceso',
    pleaseEnterTheOTC: 'Por favor, introduce el código de un solo uso que te enviamos a',
    createPasskeySingleText: 'Crear clave de acceso',
    youAreAllSet: '¡Todo listo!',
    aPasskeyHasBeenCreated: '¡Se ha creado una clave de acceso para tu perfil de NBCUniversal! Ahora podrás iniciar sesión con tu huella digital, rostro o código de desbloqueo de pantalla.',
    thereAreNoResultsThatMatch: 'No hay resultados que coincidan con "%search%"',
    ctvSuccessHeader: 'You are ready to stream!',
    ctvSuccessText: 'You have successfully activated your device using your NBCUniversal Profile. Your device will refresh to continue.',
    ctvLeftTitle: 'Use your NBCUniversal Profile',
    ctvLeftSubtitle: 'to activate device and unlock content instantly',
    ctvSuccessSubtitle: 'Your journey across all NBCUniversal brands starts from here! You can now continue to explore.',
    createProfilePasskeyFlowWelcomeVar2: 'Ahora puedes configurar una clave de acceso e iniciar sesión usando tu huella digital, reconocimiento facial o el código de acceso de tu pantalla. Para habilitar el inicio de sesión con clave de acceso, por favor ingresa el código de un solo uso que enviamos a:',
  },
}

export default TRANSLATIONS
